export default __webpack_public_path__ + "static/item_18-c1c017735eb3aa28afffe3a340cd4321.jpg";